import { Alert, Box } from '@mui/material';
import type { SegmentAttentionContext } from 'app/utils/hilSegmentsAttentionUtils';
import { TemplateGenerationSettingsComponent } from 'app/pages/TemplateGenerationSettingsComponent';

type TemplateIntentEntityPanelProps = {
  dealerId: string;
  context: SegmentAttentionContext;
};

export default function TemplateIntentEntityPanel({
  dealerId,
  context,
}: TemplateIntentEntityPanelProps) {
  if (!dealerId.trim()) {
    return (
      <Alert severity="info" sx={{ borderRadius: 2 }}>
        Select a dealer to view template intent settings.
      </Alert>
    );
  }

  const segmentName = context?.segment_name?.trim() ?? '';
  if (!segmentName) {
    return (
      <Alert severity="info" sx={{ borderRadius: 2 }}>
        No segment name was found for this attention row.
      </Alert>
    );
  }

  return (
    <Box sx={{ minHeight: 0, flex: 1, overflow: 'auto' }}>
      <TemplateGenerationSettingsComponent
        defaultExpanded
        filterSegmentName={segmentName}
        embedded
      />
    </Box>
  );
}

